import {formatErrors} from '../../../constants';

/**
 * Отказ сервера по материалам — словами сотрудника.
 *
 * Ручки раздела отвечают телом вида `{"error":"material_not_found"}`, а общий
 * разбор ответов кладёт это тело в текст ошибки как есть. Без перевода в тосте
 * оказывался json или «Request URI is not found!» — сообщение про адрес, из
 * которого сотрудник делает вывод, что сломалась панель, и идёт жаловаться
 * вместо того, чтобы обновить список.
 */
export function materialError(err) {
  const text = err && err.message ? String(err.message) : '';

  // Материала или ступени уже нет: их убрали, пока форма была открыта. Список к
  // этому моменту перечитан, и строка со экрана пропадёт сама
  if (text.indexOf('material_not_found') >= 0) {
    return 'Этого материала уже нет — список обновлён';
  }
  if (text.indexOf('storage_disabled') >= 0) {
    return 'Хранилище файлов выключено на сервере — файл заливать некуда';
  }
  if (text.indexOf('title required') >= 0) {
    return 'Заполните название';
  }
  if (text.indexOf('stage required') >= 0) {
    return 'Выберите ступень';
  }
  if (text.indexOf('unknown material kind') >= 0) {
    return 'Выберите вид материала: видеозапись или пособие';
  }
  if (text.indexOf('file_required') >= 0 || text.indexOf('file_unreadable') >= 0) {
    return 'Выберите файл заново — этот не читается';
  }

  return formatErrors([text]);
}
